import React from 'react'
import { authRoutes } from '../../../../routes'
import { Box, ThemeIcon, NavLink } from '@mantine/core'
import { useNavigate, useLocation } from 'react-router-dom'

const LayoutSidebar = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const mappingMenuAdmin = (dataRoute) => {
    // eslint-disable-next-line
    const remapRoute = dataRoute.map((val, index) => {
      if (val.type === 'route') {
        return (
          <NavLink
            key={index}
            label={
              <span 
                style={{ 
                  textTransform: 'capitalize',
                  fontSize: '12.5px', 
                  color: val.route === pathname ? '' : 'rgb(174, 176, 179)', 
                  fontWeight: val.route === pathname ? '600' : ''
                }}
              >
                {val.name}
              </span>
            } 
            leftSection={<ThemeIcon color={val.route === pathname ? '' : 'gray.5'} variant='light' radius="md" size="md">{val.icon}</ThemeIcon>}
            active={val.route === pathname || undefined}
            mb={8}
            onClick={(event) => {
              event.preventDefault()
              navigate(`${val.route}`)
            }}
            style={{ fontWeight: val.route === pathname ? '500' : '' }}
          />
        )
      } else if (val.type === 'group') {
        console.log('aaa')
      }
    })
    return remapRoute
  }
  return (
    <Box p='lg'>
      {mappingMenuAdmin(authRoutes)}
    </Box>
  )
}

export default LayoutSidebar